import { render, staticRenderFns } from "./CompanyStandsTable.vue?vue&type=template&id=48f0564e&"
import script from "./CompanyStandsTable.vue?vue&type=script&lang=ts&"
export * from "./CompanyStandsTable.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyStandsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDataTable,VListItem,VListItemContent,VListItemGroup,VMenu})
